import React, { Component } from "react";
import {
	Row, Col
} from "reactstrap";

import OperationsExportOrder from "./Export/Order";
import OperationsExportInvoice from "./Export/Invoice";
import OperationsExportAdvancedInvoice from "./Export/AdvancedInvoice";


export default class OperationsExport extends Component {
	render() {
		return (
			<div className="container-fluid">
				<Row>
					<Col md={12} sm={12} lg={4}>
                        <OperationsExportOrder />
					</Col>
					<Col md={12} sm={12} lg={4}>
                        <OperationsExportInvoice />
					</Col>
                    <Col md={12} sm={12} lg={4}>
						<OperationsExportAdvancedInvoice />
                    </Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export.js